<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OIxnl5/images/cover.png?1692135101277" alt="This image is the cover for the book An Irresistible Temptation (The Defiant Hearts Series, Book 2), The Defiant Hearts Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">An Irresistible Temptation (The Defiant Hearts Series, Book 2), The Defiant Hearts Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Their Plans Will Separate Them Forever in <i>An Irresistible Temptation</i>, by Sydney Jane Baily</b><br/><br/>Disembarking the train at the tiny town of Spring City, Colorado, classical pianist Sophie Malloy didn't expect to be knocked into the street by a dusty cowboy with a devastatingly sexy grin. <br/>Riley Dalcourt—the dusty cowboy—is stunned. At first sight, he knows Sophie is the woman for him, right down to her purple unmentionables. Unfortunately, he’s already engaged. Honor bound, he’s determined to go through with his commitment. Yet he simply can’t stay away from the sweet-tempered beauty who has entered his life so unexpectedly, or forget her when she leaves just as quickly.<br/>Traveling from San Francisco and the dangerous Barbary Coast, Sophie and Riley reunite while pursuing their individual dreams that, if fulfilled, will pull them apart forever.<br/><br/>THE DEFIANT HEARTS SERIES, in order <br/>An Intriguing Proposition<br/>An Improper Situation<br/>An Irresistible Temptation<br/>An Inescapable Attraction<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sydney Jane Baily
      </h2>
      
      <p class="authorDescription body article">Sydney Jane Baily completed her first novel at the tender age of 17. Thankfully, that manuscript resides in an undisclosed secure location. After spending years as a book editor, Sydney is thrilled to be crafting her own stories of a bygone era. She resides in New England with her family—human, feline, and canine. www.sydneyjanebaily.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ePublishing Works!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a8f0ed62